import React from "react";

import { Box, Slider, Stack, styled, Typography } from "@mui/material";
import useAtlasData from "components/pages/BitcoinerChallenge/Atlas/module/useAtlasData";
import { fontWeight } from "config/Theme/options";
import { useMUIThemeModeContext } from "context/MUIThemeModeContext";
import { useTranslation } from "react-i18next";
import { renderNumber } from "utils/formatter";

export const XPBarSlider = styled(Slider, {
  shouldForwardProp: (prop) => prop !== "success",
})<{ success?: boolean }>(({ theme, success }) => {
  const { colors } = useMUIThemeModeContext();

  return {
    pointerEvents: "none",
    color: success ? colors["success"] : theme.palette.primary.main,
    height: 9,

    "&.MuiSlider-root": {
      padding: 0,
    },

    "& .MuiSlider-track": {
      boxShadow: "2px 0px 4px 0px rgba(0, 0, 0, 0.1)",
    },
    "& .MuiSlider-rail": {
      backgroundColor: colors.gray200,
      opacity: 1,
      height: 5,
    },
    "& .MuiSlider-mark": {
      display: "none",
    },
    "& .MuiSlider-thumb": {
      height: 5,
      width: 5,
      marginLeft: -3,
      backgroundColor: colors.white,
      "&:before": {
        boxShadow: "none",
      },
    },
  };
});

const Atlas: React.FC = () => {
  const { t } = useTranslation();
  const { colors } = useMUIThemeModeContext();
  const { totalMax, totalDone } = useAtlasData();
  const isDone = totalDone >= totalMax;

  const getProgressPercentage = () => {
    if (totalMax === 0) return 0;
    return Math.round((100 * totalDone) / totalMax);
  };

  return (
    <Box width={"100%"} pt={2}>
      <Stack direction={"row"} justifyContent={"space-between"}>
        <Typography fontWeight={fontWeight.semiBold} fontSize={"0.875rem"}>
          {t("bitcoinerChallenge.atlas.title")}
        </Typography>
        <Typography fontWeight={fontWeight.semiBold} color={isDone ? colors["success"] : "primary.main"} fontSize={"0.875rem"}>
          {`${renderNumber(totalDone)}\u00a0/\u00a0${renderNumber(totalMax)}\u00a0XP`}
        </Typography>
      </Stack>
      <XPBarSlider min={0} max={100} value={getProgressPercentage()} success={isDone} />
    </Box>
  );
};

export default Atlas;
